import { produce } from 'immer';
import { create } from 'zustand';
import { VaultClient } from '@velocity-exchange/vaults-sdk';
import { PeriodApy } from 'src/@types/vaults';
import { SortableHeaderType } from 'src/components/Vaults/type';

export interface VaultsStore {
	set: (x: (s: VaultsStore) => void) => void;
	get: () => VaultsStore;
	vaultClient: VaultClient | undefined;
	areVaultConfigsLoaded: boolean;

	// needed for mobile filters
	setVaultDisplaySettings: (
		fn: (draft: VaultsStore['vaultDisplaySettings']) => void
	) => void;

	getVaultDisplaySettings: () => VaultsStore['vaultDisplaySettings'];

	vaultDisplaySettings: {
		depositedOnly: boolean;
		targetVaultManager: string;
		targetDepositAsset: string;
		targetApyPeriod: PeriodApy;
		sortedBy: SortableHeaderType;
	};

	/**
	 * The currently active tab in the vaults view
	 */
	activeTab: 'verified' | 'community' | 'my_positions';
	setActiveTab: (tab: 'verified' | 'community' | 'my_positions') => void;
}

export const useVaultsStore = create<VaultsStore>((set, get) => {
	const _setState = (fn: (draft: VaultsStore) => void) =>
		set(produce(fn) as (s: VaultsStore) => VaultsStore);

	return {
		set: _setState,
		get: () => get(),
		vaultClient: undefined,
		areVaultConfigsLoaded: false,

		vaultDisplaySettings: {
			depositedOnly: false,
			targetVaultManager: 'All',
			targetDepositAsset: 'All',
			targetApyPeriod: '90d',
			sortedBy: 'tvl',
		},

		activeTab: 'verified',
		setActiveTab: (tab: VaultsStore['activeTab']) => {
			set(() => ({
				activeTab: tab,
			}));
		},

		getVaultDisplaySettings: () => {
			return get().vaultDisplaySettings;
		},

		setVaultDisplaySettings: (
			fn: (draft: VaultsStore['vaultDisplaySettings']) => void
		) => {
			_setState((state) => {
				fn(state.vaultDisplaySettings);
				return state;
			});
		},
	};
});
